import axios from './config/axios'
const getMemberByClaimKey = (claimKey) => {
  return axios
    .get(`/api/forms/members/${claimKey}`)
    .then(r => r.data)
}
export default getMemberByClaimKey